module.exports = __webpack_public_path__ + "static/img/0755.3704ad4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/0755.jpg
// module id = 94
// module chunks = 0